import { HubConnection } from '@microsoft/signalr';
import { debounce } from 'lodash';

import { SignalRDefaultDebounceOptions, SignalRDefaultDebounceTimeout } from '../../../../../Config';
import { store } from '../../../../../shared/store';
import { PostAcutePaths } from '../../../../paths';
import { fetchNewAdmits } from '../slice';

const handleRefresh = async () => {
    // Only reload if the user is currently on the new admits page
    if (window.location.pathname === PostAcutePaths.NewAdmits.Index) {
        await store.dispatch(fetchNewAdmits());
    }
};

export const initNewAdmitsHubConnection = (connection: HubConnection) => {
    connection.on(
        'PatientIntakeAdded',
        debounce(
            async () => {
                await handleRefresh();
            },
            SignalRDefaultDebounceTimeout,
            SignalRDefaultDebounceOptions
        )
    );

    connection.on(
        'PatientIntakeUpdated',
        debounce(
            async () => {
                await handleRefresh();
            },
            SignalRDefaultDebounceTimeout,
            SignalRDefaultDebounceOptions
        )
    );

    connection.on(
        'PatientIntakeDischarged',
        debounce(
            async () => {
                await handleRefresh();
            },
            SignalRDefaultDebounceTimeout,
            SignalRDefaultDebounceOptions
        )
    );
};
